module.exports = __webpack_public_path__ + "img/115.31b2fa1a.svg";